/**
 * Human-friendly link label: drop the protocol, `www.`, query string, hash and any
 * trailing slash. e.g. "https://www.patreon.com/SamSaysEnglish?ref=x" → "patreon.com/SamSaysEnglish".
 */
export function prettyUrl(url: string): string {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, '');
    const path = u.pathname.replace(/\/$/, '');
    return `${host}${path}`;
  } catch {
    return url
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .split(/[?#]/)[0]
      .replace(/\/$/, '');
  }
}
